import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Attachment } from '../models/uploaded-file-list.model';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  public fileDeleteEvent = new Subject<boolean>();
  public fileAddEvent = new Subject<Attachment>();
  public pendingInvoiceEvent = new Subject<boolean>();
  public AcceptJobAsInProgressEvent = new Subject<boolean>();
  public QRConvertToWOEvent = new Subject<boolean>();
  public WOConvertToQREvent = new Subject<boolean>();
  constructor() {}
}
